import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FormFieldComponent } from '../form-field/form-field.component';
import { IIcon } from '../../../icon/icon.component';
import { ITrackingObject } from 'i2g-ng-tracking';

@Component({
  selector: 'i2g-toggle-field',
  templateUrl: 'toggle-field.component.html',
  styleUrls: ['toggle-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleFieldComponent extends FormFieldComponent {
  @Input() label: string;
  @Input() hideLabel: boolean;
  @Input() hideToggleButton = false;
  @Input() description: string;
  @Input() showDivider = true;
  @Input() fieldId: string;
  @Input() fieldControl: AbstractControl;
  @Input() icon: IIcon;
  @Input() toggleInputE2eId: string;
  @Input() toggleLabelE2eId: string;
  @Input() labelE2eId: string;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingIdentifier: string;
  @Input() trackingScreenName: string;
  @Input() trackingAdditionalProperties: any;
  @Input() setupText: string;

  @Output() click: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() clickIcon: EventEmitter<void> = new EventEmitter<void>();
  @Output() clickSetup: EventEmitter<Event> = new EventEmitter<Event>();

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    translateService: TranslateService
  ) {
    super(changeDetectorRef, translateService);
  }
}
